import React, { useState, useContext, useEffect } from 'react';
import useSectionStyles from './styles';
import PageContext from '../../contexts/pageContext';
import { postApiCall } from '../../utils/services';
import Button from '.././../components/button';
import Input from '../../components/input';
export default function SubscribeToNewsletter({ sectionData }) {
  const {
    layout: { containerWidth },
    baseURLs,
    isMobile,
    validations,
    isPreview,
    isEdit,
    isLandingPages,
    extraProps
  } = useContext(PageContext);
  const [nodeData] = sectionData.components;
  const classes = useSectionStyles({ containerWidth, isMobile });

  let formInitialValue = nodeData?.inputField?.metadata?.value;
  const [inputVal, setInputVal] = useState(formInitialValue);
  let [isValid, setIsValid] = useState(true);
  let [btnDisabled, setBtnDisabled] = useState(false);

  const handleSubmit = () => {
    let data = {
      sectionId: sectionData.sectionId,
      sectionType: sectionData.type,
      payload: {
        studentEmail: {
          type: 'email',
          value: inputVal
        }
      },
      orgCode: extraProps?.org_code,
      orgId: extraProps?.org_id,
      ...(isLandingPages && {
        source: 'landing_page'
      })
    };
    if (!(isPreview || isEdit)) postApiCall(baseURLs, data);
    setBtnDisabled(true);
    setInputVal(formInitialValue);
  };

  const checkValidity = () => {
    if (validations?.[nodeData?.inputField?.metadata?.validationType]?.length) {
      let regex = new RegExp(
        validations[nodeData?.inputField?.metadata?.validationType]
      );
      if (regex?.test(inputVal)) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    }
  };

  useEffect(() => {
    if (!isValid) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [isValid]);

  return (
    <section className={classes.section}>
      <div className={classes.newsLetterContainer}>
        <div className={classes.partialBackground} />
        <div className={classes.sectionContainer}>
          <h2 className={classes.cardHeading}>
            <span
              ref={nodeData?.cardHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData.cardHeading.metadata.value
              }}
            />
          </h2>
          <div className={classes.contentContainer}>
            <div
              ref={nodeData?.title?.refSetter}
              className={classes.title}
              dangerouslySetInnerHTML={{
                __html: nodeData.title.metadata.value
              }}
            />
            <div className={classes.inputContainer}>
              <div className={classes.inputFieldDiv}>
                <Input
                  data={nodeData?.inputField}
                  value={inputVal}
                  isValid={isValid}
                  style={{ padding: '12px 16px' }}
                  inputType={'input'}
                  onChange={(e) => {
                    setInputVal(e.target.value);
                    setBtnDisabled(false);
                  }}
                  onBlur={() => {
                    checkValidity();
                  }}
                  onFocus={() => {
                    setIsValid(true);
                  }}
                />
              </div>
              {nodeData.cta.metadata.value !== '' && (
                <div className={classes.btnContainer}>
                  <Button
                    ref={nodeData?.cta?.refSetter}
                    data={
                      btnDisabled && isValid
                        ? { value: 'Submitted' }
                        : { value: nodeData?.cta?.metadata?.value }
                    }
                    onClick={() => handleSubmit()}
                    type={nodeData?.cta?.metadata?.type}
                    size={'small'}
                    styling={
                      isMobile
                        ? { marginTop: '12px' }
                        : {
                            maxWidth: '200px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }
                    }
                    disabled={btnDisabled}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
